import axios from 'axios';
import config from '../../config';
import { useLocation } from 'react-router-dom';


// 이메일 포맷 체크
export const isEmailFormatChk = (email : string) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
       
    return emailPattern.test(email);
}

// 비밀번호 형식 체크 (대소문자, 숫자, 특수문자 조합 9~12자리, '.', ',' 제외)
// 변경시 backend에서도 동일한 함수 변경 필요
export const isPassWdFormatChk = (password: string) => {
    // 패턴 체크
    const passwordPattern = /^(?!.*(.)\1{2})(?=.{10,16}$)(?=(?:((?=.*[A-Za-z])(?=.*\d))|((?=.*\d)(?=.*[!@#$%^&*()_+=-]))|((?=.*[A-Za-z])(?=.*[!@#$%^&*()_+=-]))))[A-Za-z\d!@#$%^&*()_+=-]*$/;

    const hasForbiddenChars = /[.,]/.test(password);
    if (!passwordPattern.test(password) || hasForbiddenChars) {
        return false;
    }

    // 연속된 숫자 3자리 이상 되지 않도록
    const hasSequentialNumbers = (password: string): boolean => {
        for (let i = 0; i < password.length - 2; i++) {
        const a = password.charCodeAt(i);
        const b = password.charCodeAt(i + 1);
        const c = password.charCodeAt(i + 2);

        if (
            isDigit(a) &&
            ((b === a + 1 && c === b + 1) || (b === a - 1 && c === b - 1)) // e.g., 123 or 987
        ) {
            return true;
        }
        }
        return false;
    };

    const isDigit = (charCode: number): boolean => charCode >= 48 && charCode <= 57;

    return !hasSequentialNumbers(password);
}

// byte 값을 단위변경
export const getBytesToSize = (bytes: number,unitIdx: number) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return `0  ${sizes[unitIdx]}`;
    
    return `${getFormatCurrencyStr((bytes / Math.pow(1024, unitIdx)).toFixed(2))} ${sizes[unitIdx]}`;
}

// byte 값을 단위변경
export const getBytesToSizeNumber = (bytes: number) : number => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 0;
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const returnV = Number((bytes / Math.pow(1024, i)).toFixed(1));

    return returnV;
}

// 추가 금액 계산
export const getAddPayNumber = (totalDataNumber: number , useDataNumber:number) : number => {
    const addPay = Math.ceil((useDataNumber - totalDataNumber)/1024/1024/1024)*10000

    return addPay;
}

export const getFormatCurrencyStr = (amount: string) => {
    return new Intl.NumberFormat('ko-KR').format(Number(amount));
}

export const getFormatCurrency = (amount: number) => {
    return new Intl.NumberFormat('ko-KR').format(amount);
}

export async function openInfoPage (pageNo: string) {
    const pageUrl = config.infoseedApiUrl + "/v1/page";
    const infoseed_token  = localStorage.getItem('infoseed_token');
    
    try {
        const response = await fetch(pageUrl, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${infoseed_token}`,
                PAGE_CD : pageNo
            },
        });
    
        if (response.ok) {

            

            const access_token  = localStorage.getItem('access_token');

            const data = await response.json();
            
            // console.log('info api 리턴 결과:', JSON.stringify(data, null, 2));

            const form = document.createElement('form');
            form.method = 'GET';
            form.action = data.data.URL;
            form.target = 'infoseed-window';
            
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = "ptoken";
            hiddenField.value = access_token!;
            form.appendChild(hiddenField);

            const hiddenField2 = document.createElement('input');
            hiddenField2.type = 'hidden';
            hiddenField2.name = "apikey";
            hiddenField2.value = config.infoseedApiKey!;
            form.appendChild(hiddenField2);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form); // 양식 제거
            
        } else {
            console.error('Failed to fetch data:', response.statusText);
        }
    } catch(e) {
        alert("페이지 연동시 오류가 발생하였습니다.");
    }
    
}

export async function moveInfoPage (pageUrl: string) {
    alert(pageUrl);
    const access_token  = localStorage.getItem('infoseed_token');
    
    try {
        const response = await fetch(pageUrl, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${access_token}`,
            },
        });
        
    
        if (response.ok) {
            const data = await response.text();
            
            // console.log('info api 리턴 결과:', JSON.stringify(data, null, 2));

            alert(pageUrl);

            const newWindow = window.open(pageUrl);
            if (newWindow) {
                newWindow.document.write('<pre>' + data + '</pre>');
                newWindow.document.close();
            }
            
        } else {
            console.error('Failed to fetch data:', response.statusText);
        }
    } catch(e) {
        alert("페이지 연동시 오류가 발생하였습니다.");
    }
    
}

export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
